import React from 'react';
import IndexTable from '../index-table/IndexTable';
import SparePartsFinderIndexTableRow from './SparePartsFinderIndexTableRow';

export default class SparePartsFinderIndexTable extends IndexTable {
    static defaultProps = {
        features: []
    }

    rowComponentClass = SparePartsFinderIndexTableRow;

    renderTableActions = () => (
        <React.Fragment>
            <h3>{__('Results')}</h3>
            {this.props.page.renderExportDropdown()}
        </React.Fragment>
    )
}
